import React from 'react';
import IconBulb from '@/pages/opinion/assets/svg/icon-bulb.svg';
import { keywordsTipsConfig } from '../utils'; 
import './index.scss';
import _ from 'lodash-es';
import useLanguage from '@op/hooks/useLanguage';

export default function KeywordTips({
  isBubble = false,
}: {
  isBubble?: boolean;
}) {
  const { formatMessage } = useLanguage();

  function dealwithParams(obj: { text: string; text1?: string }) {
    const result: any = {};
    _.forEach(obj, (element: string, key: string) => {
      result[key] = <b>{element}</b>;
    });

    return result;
  }

  return (
    <div className={`dbo-customs-keywords ${isBubble ? 'dbo-bubble' : ''}`}>
      <div className="dbo-customs-keywords-tips">
        {formatMessage({
          id: 'Enter custom keywords for exact-match or expand-match, supporting AND/OR relationships for precise filtering.',
        })}
      </div>
      <div className="dbo-customs-keywords-tips" style={{ fontWeight: 'bold' }}>
        {formatMessage({
          id: 'Note: The extended search currently only supports the "OR" search, which is the input of the ";" symbol.',
        })}
      </div>
      <div className="dbo-customs-keywords-title">
        <img src={IconBulb} className="tip-icon" />
        {formatMessage({ id: 'Syntax examples' })}
        <span> {formatMessage({ id: '(case-insensitive)' })}</span>
      </div>
      <div className="dbo-customs-keywords-list">
        {keywordsTipsConfig.map(({ title, desc, params }) => (
          <div className="dbo-customs-keywords-item" key={title}>
            <div className="dbo-customs-keywords-item-title">{title}</div>
            <div className="dbo-customs-keywords-item-content">
              {params
                ? formatMessage({ id: desc }, dealwithParams(params))
                : formatMessage({ id: desc })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
